import React from 'react';
import { useScreenInit } from './useScreenInit';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { AnswerFirst } from './components/AnswerFirst';
import { EmpathySection } from './components/EmpathySection';
import { ClaimRouter } from './components/ClaimRouter';
import { ProcessSection } from './components/ProcessSection';
import { MidPageCTA } from './components/MidPageCTA';
import { RoadAccidentFeature } from './components/RoadAccidentFeature';
import { CaseExperience } from './components/CaseExperience';
import { Testimonials } from './components/Testimonials';
import { WhySeparovic } from './components/WhySeparovic';
import { FeesExplained } from './components/FeesExplained';
import { TeamSection } from './components/TeamSection';
import { FAQSection } from './components/FAQSection';
import { ServiceArea } from './components/ServiceArea';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useScreenInit();
  return <div className="min-h-screen w-full bg-stone text-charcoal" data-id="element-0">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-btn focus:bg-eucalypt focus:px-4 focus:py-2 focus:text-stone" data-id="element-1">
        Skip to content
      </a>

      {/* 01 */}
      <AnnouncementBar data-id="element-2" />
      {/* 02 */}
      <Header data-id="element-3" />

      <main id="main-content" className="pb-[52px] lg:pb-0" data-id="element-4">
        {/* 03 */}
        <Hero data-id="element-5" />
        {/* 04 */}
        <TrustBar data-id="element-6" />
        {/* 05 */}
        <AnswerFirst data-id="element-7" />
        {/* 06 */}
        <EmpathySection data-id="element-8" />
        {/* 07 */}
        <ClaimRouter data-id="element-9" />
        {/* 08 */}
        <ProcessSection data-id="element-10" />
        {/* 09 */}
        <MidPageCTA data-id="element-11" />
        {/* 10 */}
        <RoadAccidentFeature data-id="element-12" />
        {/* 11 */}
        <CaseExperience data-id="element-13" />
        {/* 12 */}
        <Testimonials data-id="element-14" />
        {/* 13 */}
        <WhySeparovic data-id="element-15" />
        {/* 14 */}
        <FeesExplained data-id="element-16" />
        {/* 15 */}
        <TeamSection data-id="element-17" />
        {/* 16 */}
        <FAQSection data-id="element-18" />
        {/* 17 */}
        <ServiceArea data-id="element-19" />
        {/* 18 */}
        <FinalCTA data-id="element-20" />
      </main>

      {/* 19 */}
      <Footer data-id="element-21" />
    </div>;
}